import { Box, Flex } from '@shared/components';
import type { PropsWithOptionalChildren } from '@shared/utils';
import { useLocation } from 'react-router-dom';

import { Sidebar } from '../sidebar';

const HIDDEN_SIDE_BAR_PATHS = ['/login', '/forgot-password', '/setup-password'];

function Frame(props: Readonly<PropsWithOptionalChildren>) {
  const { children } = props;
  const location = useLocation();

  const isHiddenSidebar = HIDDEN_SIDE_BAR_PATHS.includes(location.pathname);

  return (
    <Box component='main' sx={{ width: 1, height: '100dvh', display: 'flex' }}>
      {!isHiddenSidebar ? <Sidebar /> : null}
      <Flex
        id='frame-content'
        sx={{
          minWidth: '0px',
          width: '100%',
          overflow: 'auto',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        {children}
      </Flex>
    </Box>
  );
}

export default Frame;
